import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import getCorsiCorrenti from "../../services/getCorsiInCorso";
import LoadingOverlay from "react-loading-overlay";
import getStudentiPresenze from "../../services/getStudentiPresenzeCorso";
import getStudenti from "../../services/getStudenti";
import TextNumberInput from "../../widgets/TextNumberInput";
import NotificaAssenzaWidget from "../../widgets/NotificaAssenzaWidget";
import sendNotificaAssenza from "../../services/sendNotificaAssenza";
import SendDialog from "../../widgets/SendDialog";
import getLezioni from "../../services/getLezioni";
import setDefaultPercentage from "../../services/setDefaultPercentage";
import getDefaultPercentage from "../../services/getDefaultPercentage";

const cookies = new Cookies();
const username = cookies.get("username", { path: "/" });
const token = cookies.get("token", { path: "/" });

export default class NotificheAssenze extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      presenze: [],
      corsi: [],
      requestedPercentage: 0.0,
      calculatedPercentage: 0.0,
      showSend: false,
      total: 0,
      sent: 0,
    };
  }

  async componentDidMount() {
    let perc = await getDefaultPercentage(username, token);

    this.setState({ requestedPercentage: parseFloat(perc.percentage) });

    await this.recalibrate();
  }

  async recalibrate() {
    this.setState({ isLoading: true, presenze: [], corsi: [] });
    var presenze = [];
    let corsi = await getCorsiCorrenti(username, token);
    let studenti = await getStudenti(username, token);

    if (corsi.length === 0) {
      alert("Nessun corso attivo trovato.");
      return;
    }

    var corsiTemp = [];
    for (const corso of corsi) {
      let presenzeCorso = await getStudentiPresenze(username, token, corso.id);

      var corsoTemp = [];
      var lezioniCorso = await getLezioni(username, token);
      lezioniCorso = lezioniCorso.filter(
        (l) => l.id_corso === corso.id || l.altri_corsi.includes(corso.id + ";")
      );

      var oreTotaliCorso = 0.0;
      lezioniCorso.forEach((l) => {
        oreTotaliCorso += parseFloat(l.durata) / 60;
      });

      studenti.forEach((s) => {
        const corsiArray = s.corsi.split(";").filter(Boolean);
        const corsiRitiroArray = s.corsi_ritiro.split(";").filter(Boolean);
        if (!corsiArray.includes(corso.id.toString())) return;
        if (corsiRitiroArray.includes(corso.id.toString())) return;

        var oreSvolteStudente = 0.0;
        var oreTotaliStudente = 0.0;

        let presenzeStudenteCorso = presenzeCorso.filter(
          (p) => p.id_studente === s.id
        );
        let presenzeTotali = presenzeStudenteCorso.length;
        let studentePresente = presenzeStudenteCorso.filter(
          (p) => p.presenza === 1
        );
        let studenteAssente = presenzeStudenteCorso.filter(
          (p) => p.presenza === -1
        );

        presenzeStudenteCorso.forEach((p) => {
          if (p.presenza === 1) {
            if (p.ore === "") {
              oreSvolteStudente += parseFloat(p.durata) / 60;
            } else {
              oreSvolteStudente += parseFloat(p.ore);
            }
          }
          oreTotaliStudente += parseFloat(p.durata) / 60;
        });

        let percStudente =
          100 - parseFloat(oreSvolteStudente / oreTotaliStudente) * 100;

        if (percStudente >= this.state.requestedPercentage) {
          let notificaDaMandare = {
            studente: s.nome + " " + s.cognome,
            idStudente: s.id,
            corso: corso.name,
            totaleLezioni: presenzeTotali,
            presenzeTotali: studentePresente.length,
            assenzeTotali: studenteAssente.length,
            percentualeAssenze: percStudente.toFixed(2),
            selected: true,
            percentuale: this.state.requestedPercentage,
          };
          corsoTemp.push(notificaDaMandare);
        }
      });

      if (corsoTemp.length > 0) {
        corsiTemp.push(corso.name);
        presenze.push(corsoTemp);
      }
    }

    this.setState({
      isLoading: false,
      presenze,
      corsi: corsiTemp,
      calculatedPercentage: this.state.requestedPercentage,
    });
  }

  async send() {
    if (
      !window.confirm(
        "Vuoi davvero inviare una notifica a tutti gli studenti selezionati?"
      )
    )
      return;

    var toSend = [];
    this.state.presenze.forEach((p) => {
      toSend.push(...p);
    });
    toSend = toSend.filter((p) => p.selected);
    this.setState({ showSend: true, total: toSend.length });

    for (const notifica of toSend) {
      await sendNotificaAssenza(username, token, notifica);
      this.setState({ sent: this.state.sent + 1 });
    }

    this.setState({ showSend: false });
    alert("Notifiche inviate con successo.");
  }

  changeSelection(ind_corso, ind_presenza) {
    var notifiche = this.state.presenze;
    notifiche[ind_corso][ind_presenza].selected = !notifiche[ind_corso][
      ind_presenza
    ].selected;
    this.setState({ presenze: notifiche });
  }

  toggleAll(toggle) {
    var presenze = this.state.presenze;
    presenze.forEach((p, i) => {
      p.forEach((p1, ind) => {
        presenze[i][ind].selected = toggle;
      });
    });

    this.setState({ presenze });
  }

  render() {
    var allSelected = true;
    this.state.presenze.forEach((p) => {
      p.forEach((p1) => {
        if (!p1.selected) {
          allSelected = false;
        }
      });
    });

    return (
      <div id={Math.random()}>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              height: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Calcolo le notifiche da inviare..."}
        >
          <PageTitle
            title="Notifiche assenze corsi"
            //button="INVIA NOTIFICHE"
            secondButton="RICALCOLA"
            onClick={() => {
              this.send();
            }}
            onSecondClick={async () => {
              await setDefaultPercentage(
                username,
                token,
                this.state.requestedPercentage
              );
              this.recalibrate();
            }}
          />

          <div style={{ paddingBottom: this.state.isLoading ? 500 : 0 }}>
            <TextNumberInput
              name="Percentuale di assenze limite (notifica inviata per % maggiore o uguale)."
              value={this.state.requestedPercentage}
              onChange={(text) =>
                text <= 100 &&
                text >= 0 &&
                this.setState({ requestedPercentage: text })
              }
            />
            <h2 style={{ marginLeft: 5, marginTop: 25 }}>
              Studenti con più del {this.state.calculatedPercentage}% di assenze
              (divisi per corso)
            </h2>

            {allSelected ? (
              <img
                src={require("../../images/selected.png")}
                onClick={() => this.toggleAll(false)}
                style={{
                  width: 20,
                  height: 20,
                  marginLeft: 25,
                  cursor: "pointer",
                }}
              />
            ) : (
              <div
                style={{
                  width: 20,
                  minHeight: 20,
                  borderRadius: 10,
                  backgroundColor: "darkgrey",
                  cursor: "pointer",
                  marginLeft: 25,
                }}
                onClick={() => this.toggleAll(true)}
              ></div>
            )}
            {this.state.corsi.map((corso, ind) => {
              return (
                <div style={{ marginLeft: 5 }} key={ind}>
                  <h3 style={{ marginTop: 30 }}>{corso}</h3>
                  {this.state.presenze[ind].map((presenza, i) => {
                    return (
                      <NotificaAssenzaWidget
                        assenza={presenza}
                        onSelect={() => this.changeSelection(ind, i)}
                      />
                    );
                  })}
                </div>
              );
            })}
          </div>
        </LoadingOverlay>

        {this.state.showSend && (
          <SendDialog sent={this.state.sent} total={this.state.total} />
        )}
      </div>
    );
  }
}
